import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from '../../context/LanguageContext';

const CyberCta = () => {
  const { t } = useLanguage();

  return (
    <section className="cyber-cta ">
      <div className="container">
        <div
          className="cyber-cta-bg p-5 rounded-custom"
          style={{
            background:
              "url('assets/img/cb_call_to_action.png') no-repeat center / cover",
          }}
        >
          <div className="row">
            <div className="col-lg-9 col-md-9">
              <div className="cyber-cta-info position-relative">
                <div className="">
                  <h2 className="text-white">
                    {t('cyberCta.title')}
                  </h2>
                  <p className="lead text-white mb-0">
                    {t('cyberCta.subtitle')}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cyber-cta-btn">
                <Link to="/request-demo" className="mt-3 btn btn-primary me-auto">
                  {t('cyberCta.button')} <i className="far fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CyberCta;
